/* 
Displays the region name and region based on passed id
*/
import { Text } from "@mantine/core";

export default function RegionToText(props) {
  if (!props.orchestratorName || !props.orchestratorRegion) {
    return <Text>...</Text>;
  }
  return (
    <Text
      sx={{
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
      }}
    >
      {props.orchestratorName} ( {props.orchestratorRegion} )
    </Text>
  );
}
